<template>
  <div>
    <div class="block">
      <el-carousel class="mySwipe" height="19.5rem" arrow="never">
        <el-carousel-item v-for="item in swipe" :key="item.image">
          <el-image
            style="width: 100%; height: 19.5rem"
            :src="item.image"
            fit="fill"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import api from '@/utils/api'
export default {
  name: 'Swipe',
  props: {
    swipe: {
      type: Array,
      default: null
    }
  },
}
</script>
<style scoped >
.mySwipe {
  width: 100%;
}
.block{
    width: 100%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 0.875rem;
  opacity: 0.75;
  line-height: 9.375rem;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
/deep/ .el-carousel__button {
  height: 0.5rem;
  width: 0.9375rem;
  border-radius: 3.125rem !important;
}
</style>
